import React, { useState } from 'react';
import Classes from './styles/style.module.css';
import Logo from '../Home/Components/Logo/Logo';

function TermsOfService() {
    return (
        <>
            <div
                className={Classes.navContainer}
                style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)' }}
            >
                <div>
                    <a className={Classes.logoLink} href="/">
                        <Logo alwaysShowText={true} />
                    </a>
                </div>
                <nav className={Classes.navMenu}></nav>
                <div>
                    <a href="/">
                        <h5 className={Classes.goBackTxt}>Go back to Tawaf.ai</h5>
                    </a>
                </div>
            </div>

            <form className={Classes.hero}>
                <h1>Terms of Service — Tawaf, Inc.</h1>
                <div className={Classes.form_con}>
                    <h5>Version: v1.0</h5>
                    <h5>Effective date: 2025-11-10</h5>
                    <h5>
                        Contact:{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Accepting these terms</h5>
                    <h5>
                        By using Tawaf, you agree to these Terms and our Privacy Policy.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Eligibility &amp; accounts</h5>
                    <h5>
                        You may use Tawaf if you are an adult or have verified parental/guardian
                        consent where allowed by law. You agree to keep your account information
                        accurate and your password secure. You are responsible for all activity that
                        occurs under your account.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Safe and acceptable use</h5>
                    <h5>Please use Tawaf responsibly. In particular, you agree:</h5>
                    <br />
                    <ul>
                        <li>
                            <h5>
                                Not to harass, threaten, or harm others, or post illegal or harmful
                                content.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Not to misuse location features or track others without their clear
                                consent.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Not to interfere with, disrupt, or reverse engineer the service or
                                its security.
                            </h5>
                        </li>
                    </ul>
                    <br />
                    <h5>
                        We may suspend or terminate accounts where necessary to protect users,
                        comply with law, or protect the platform.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>
                        Location features (your responsibility)
                    </h5>
                    <h5>
                        Location and group sharing are opt-in. Always use good judgment in crowded
                        or sensitive areas. Do not rely on Tawaf for emergency situations — use your
                        local emergency services instead. Maps, traffic, and other data may be
                        inaccurate, delayed, or unavailable.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Content &amp; intellectual property</h5>

                    <h5 className={Classes.mini_title}>Your content</h5>
                    <h5>
                        You own the content you submit to Tawaf. You grant us a limited,
                        worldwide, non-exclusive license to host, process, and display your content
                        as needed to operate and improve the service.
                    </h5>

                    <br />

                    <h5 className={Classes.mini_title}>Feedback</h5>
                    <h5>
                        If you provide feedback or suggestions, you allow us to use them without
                        restriction to improve Tawaf and related services.
                    </h5>

                    <br />

                    <h5 className={Classes.mini_title}>Tawaf IP</h5>
                    <h5>
                        Our software, trademarks, branding, and other content are owned by Tawaf,
                        Inc. and our licensors. You may not copy, modify, distribute, or create
                        derivative works except as allowed by law or with our written permission.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>
                        Third-party services &amp; payments
                    </h5>
                    <h5>
                        Bookings and payments (if you choose to use them) are processed by
                        third-party providers under their own terms and privacy policies. Tawaf is
                        not responsible for their availability, accuracy, errors, or policies, but
                        we aim to work with reputable providers.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Disclaimers &amp; limits of liability</h5>
                    <h5>
                        Tawaf provides informational guidance only. It does not provide medical,
                        legal, or other professional advice, and should not be used as a substitute
                        for professional judgment.
                    </h5>
                    <br />
                    <h5>
                        The service is provided “as is” and “as available,” without warranties of
                        any kind, to the fullest extent permitted by law.
                    </h5>
                    <br />
                    <h5>
                        To the extent allowed by law, our total liability for any claim arising out
                        of or relating to the service is limited to the greater of:
                    </h5>
                    <br />
                    <ul>
                        <li>
                            <h5>The amounts you paid to us for the service in the last 12 months; or</h5>
                        </li>
                        <li>
                            <h5>USD $100.</h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>
                        Ending or changing the service
                    </h5>
                    <h5>
                        You may stop using Tawaf at any time and request account deletion in
                        accordance with our Privacy Policy.
                    </h5>
                    <br />
                    <h5>
                        We may suspend, restrict, or terminate the service or your access where
                        necessary for policy, operational, security, or legal reasons.
                    </h5>
                    <br />
                    <h5>
                        We may update these Terms from time to time. If changes are material, we
                        may notify you via the app or email. Your continued use of the service after
                        changes become effective means you accept the updated Terms.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>
                        Governing law &amp; disputes (simple)
                    </h5>
                    <h5>
                        Unless otherwise required by local law, these Terms are governed by the laws
                        of the State of Delaware, USA.
                    </h5>
                    <br />
                    <h5>
                        Disputes may be resolved through arbitration administered by JAMS in
                        Wilmington, Delaware, or another agreed venue, subject to applicable law.
                    </h5>
                    <br />
                    <h5>
                        For Saudi Arabia (KSA) and United Arab Emirates (UAE)-targeted deployments,
                        mandatory local consumer and data protection laws apply in addition to these
                        Terms.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Contact</h5>
                    <h5>
                        For questions about these Terms, contact:{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Human summary</h5>
                    <h5>
                        Use Tawaf responsibly — especially with location sharing. We provide tools
                        and guidance, not medical or legal advice. Some services are delivered by
                        third parties.
                    </h5>

                    <br />
                </div>
            </form>
        </>
    );
}

export default TermsOfService;
